import React, { FunctionComponent } from 'react';

import { SegmentedControlOptions } from 'scenes/common/components/Questions';
import { KickOutStep as CommonKickOutStep } from 'scenes/common/components/Steps';

import { HomeFullPageProps, KickOutChoice } from 'scenes/home/types';
import { getKickOutChoice } from 'scenes/home/selectors';
import { landlordInsuranceQuoteUrl } from 'scenes/common/helpers/contacts';

const HELP_TEXT =
  'Based on your selection above you are not eligible for Coles Home Insurance. Click below to start a Coles Landlord Insurance quote instead.\n';

const OPTIONS: SegmentedControlOptions<KickOutChoice, KickOutChoice> = [
  { label: KickOutChoice.ChangeOfMind, value: KickOutChoice.ChangeOfMind },
  {
    label: KickOutChoice.StickWithTheChoice,
    value: KickOutChoice.StickWithTheChoice,
  },
];

const KickOutStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
  onUpdateKickOutChoice,
}) => {
  const choice = getKickOutChoice(funnelState);

  return (
    <CommonKickOutStep
      onNext={onNext}
      helpText={HELP_TEXT}
      options={OPTIONS}
      defaultStateValue={choice}
      onUpdateKickOutChoice={onUpdateKickOutChoice}
      redirectUrl={
        choice === KickOutChoice.StickWithTheChoice
          ? landlordInsuranceQuoteUrl()
          : undefined
      }
    />
  );
};

export default KickOutStep;
